<template>
  <div class="MarketType bc-white pt7 text-left" v-title data-title="行情类型">
    <van-tabs
      v-model="quoteType"
      :offset-top="0"
      sticky
      type="card"
      color="#1e67c7"
      @click="changeQuoteType"
    >
      <van-tab  v-for="quoteType in quoteTypes" :key="quoteType.value" :title="quoteType.text" :name="quoteType.value"></van-tab>
    </van-tabs>
    <div class="text-center pb7 pt7">
      <van-button @click="back" class="btn-common" type="info" plain style="">返 回</van-button>
      <van-button @click="edit()" class="btn-common" type="info" style="margin-left: 10px;">添加类型</van-button>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div v-for="(rc) in records" :key="rc.id"
        @click="edit(rc)"
        class="row align-items-center records-item records-line"
      >
        <div class="flex-1">
          <div v-for="(h) in heads" :key="h.field" class="pt3 row align-items-baseline">
            <span class="record-label fc-less">{{h.title}}</span>
            <span class="flex-1">
              <template v-if="h.multi">
                <template v-for="(lst, lstindex) in rc[h.field]">
                  <div v-if="lstindex > 0" class="line-dashed mt5 pb5" :key="`${lstindex}_line`"></div>
                  <div :key="lstindex">
                      {{lst.remark}}
                  </div>
                </template>
              </template>
              <template v-else>{{rc[h.field]}}</template>
            </span>
          </div>
        </div>
        <van-icon @click="edit(rc)" class="fc-less" name="arrow" />
        <!-- <van-icon class="fs10" name="records" />
        <van-icon class="fs10" name="delete" /> -->
      </div>
    </van-list>
    <!-- 新增/编辑 -->
    <van-popup
      v-model="editShow"
      position="bottom"
    >
      <div class="pl5 pr5 pt10 pb10">
        <div class="text-center pb5">新增/编辑行情类型</div>
        <div class="row pt3" :class="h.type==='upload'?'align-items-start':'align-items-baseline'" v-for="h in heads" :key="h.field">
          <div class="edit-label fc-less fs4">{{h.title}}</div>
          <div v-if="h.multi" class="flex-1">
            <div class="row align-items-center" :class="mdindex===0?'':'pt2'"
              v-for="(md, mdindex) in editItem[h.field]"
              :key="mdindex">
              <van-field
                class="flex-1 ml2"
                v-model="md.remark"
                rows="1"
                type="textarea"
                autosize
                clearable
                :placeholder="`备注${mdindex+1}`"
              />
              <van-icon v-if="mdindex + 1 === editItem[h.field].length"
                @click="addMulti(h.field)" name="add-o" size="20px" class="ml1"/>
              <van-icon v-else
                @click="removeMulti(h.field, mdindex)" name="close" size="20px" class="ml1 fc-danger"/>
            </div>
          </div>
          <div v-else class="flex-1">
            <van-field
              v-model="editItem[h.field]"
              clearable
              :placeholder="'请输入'+h.title"
            />
          </div>
        </div>
        <div class="text-center pt10">
          <van-button @click="close()" class="btn-common" type="info" plain style="">关 闭</van-button>
          <van-button @click="save()" class="btn-common" type="info" style="margin-left: 10px;">保存</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getMarketTypeList, addMarketType, updateMarketType, getMarketVarieties,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'MarketType',
  components: { },
  data() {
    return {
      loading: false,
      isAdmin: storage.local.get('type') === 1, // 1 管理员 2 报价商 3 测试 4 生产的测试用户
      error: false,
      finished: false,
      size: 20,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      params: {},
      heads: [
        { title: '行情类型', field: 'typeName' },
        {
          title: '备注', field: 'remark', multi: true,
        },
      ],
      totalCount: 0,
      editShow: false,
      editItem: {},
      quoteTypes: [],
      quoteType: '',
    };
  },
  methods: {
    getMarketVarieties() {
      return sendRequest(getMarketVarieties, {}).then((res) => {
        this.quoteTypes = res || [];
        this.quoteType = this.quoteTypes[0].value;
        this.changeQuoteType(this.quoteType);
      });
    },
    changeQuoteType(val) {
      // this.getMarketTypes();
      this.getMarketType();
    },
    save() {
      const { id = '', remark = [] } = this.editItem;
      const method = id ? updateMarketType : addMarketType;
      sendRequest(method, {
        ...this.editItem,
        remark: remark.filter(rm => rm.remark).map(rm => rm.remark),
        variety: this.quoteType,
      }).then(() => {
        this.close();
        // this.records.push(this.editItem);
        this.getMarketType();
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    close() {
      this.editShow = false;
    },
    edit(item = {}) {
      this.editShow = true;
      this.editItem = JSON.parse(JSON.stringify(item));
      if (!this.editItem.remark || !this.editItem.remark.length) {
        this.addMulti('remark');
      }
    },
    addMulti(filed = '') {
      const list = this.editItem[filed] || [];
      list.push({
        remark: '',
      });
      this.$set(this.editItem, filed, list);
    },
    removeMulti(filed = '', index) {
      const list = this.editItem[filed] || [];
      list.splice(index, 1);
      this.$set(this.editItem, filed, list);
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getMarketType(this.current + 1);
    },
    getMarketType(page = 1) {
      this.loading = true;
      sendRequest(getMarketTypeList, {
        current: page,
        size: this.size,
        variety: this.quoteType,
      }).then((res) => {
        this.finished = true;
        this.records = (res || []).map(item => ({
          ...item,
          remark: (item.remark || []).map(rm => ({ remark: rm })),
        }));
        this.error = false;
        this.total = this.records.length;
      }).catch((e) => {
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    back() {
      this.$router.push('/market/info/home');
    },
  },
  created() {
    this.getMarketVarieties();
  },
});
</script>
<style scoped>
  .MarketType {
    min-height: 100vh;
    padding-left: 5px;
    padding-right: 5px;
  }
  .MarketType .required-box {
    width: 90px;
  }
  .MarketType >>> .records-item {
    background-color: #ffffff;
    /* margin-top: 10px; */
    padding: 2px 0 10px 0;
    border-top: 1px solid #c7c1c1;
    /* margin-top: 10px; */
    /* border-radius: 6px; */
  }
  .MarketType .record-label {
    width: 100px;
    padding-left: 10px;
  }
  .MarketType .record-list {
    /* border-radius: 6px; */
    padding: 2px 4px;
    border: 1px solid #1989fa;
  }
  .MarketType .edit-input {
    width: 100%;
    border: 1px solid #b1aeae;
    border-radius: 4px;
    padding: 3px 4px;
    /* height: 38px; */
  }
  .MarketType .edit-label {
    width: 100px;
    padding-right: 5px;
  }
</style>
